module.exports = __webpack_public_path__ + "img/triangle1.442fb9ef.svg";